var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.02 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.82;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.23,6.62A5.81,5.81,0,0,0,48,4.83H39.44V4.72a4.57,4.57,0,0,0-1.39-3.33A4.66,4.66,0,0,0,34.71,0H19.31a4.75,4.75,0,0,0-4.78,4.72v.11H6.06A5.79,5.79,0,0,0,1.8,6.62,6.11,6.11,0,0,0,0,10.89V36.46a5.81,5.81,0,0,0,1.8,4.26,6.1,6.1,0,0,0,4.26,1.8H48a5.82,5.82,0,0,0,4.27-1.8A6.14,6.14,0,0,0,54,36.46V10.89A5.81,5.81,0,0,0,52.23,6.62Zm-.88,29.84H51.3A3.33,3.33,0,0,1,48,39.8H6.06a3.35,3.35,0,0,1-3.34-3.34V10.89A3.33,3.33,0,0,1,6.06,7.55H16a1.39,1.39,0,0,0,1.39-1.39V4.67a2,2,0,0,1,.56-1.43,2,2,0,0,1,1.44-.57H34.71a2,2,0,0,1,1.44.57,2,2,0,0,1,.57,1.43V6.16A1.38,1.38,0,0,0,38.1,7.55H48a3.31,3.31,0,0,1,3.34,3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27,11A12.62,12.62,0,1,0,36,14.74,12.65,12.65,0,0,0,27,11Zm7,19.67a9.94,9.94,0,0,1-14,0,9.81,9.81,0,0,1-2.88-7,10,10,0,0,1,2.88-7,9.78,9.78,0,0,1,7-2.87,10,10,0,0,1,7,2.87,9.84,9.84,0,0,1,2.87,7A9.64,9.64,0,0,1,34,30.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 45.29,
    cy: 13.51,
    r: 2.52
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.a9403a069a6769c1852a6aa1c4a5d785.svg";
export { ForwardRef as ReactComponent };